import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Router} from '@angular/router';
import {Observable, of} from 'rxjs';
import {User} from '../User';
import {SessionsService} from '../sessions.service';
import {environment} from '../../environments/environment';
import {Environment} from '@angular/compiler-cli/src/ngtsc/typecheck/src/environment';
@Injectable({
  providedIn: 'root'
})
export class ApiService {

  API_URL = (environment.production) ? /* "https://assetlicences.herokuapp.com" */"https://database.assetx.it:3443":
    "http://localhost:8081";

  constructor(
    private router: Router,
    private http: HttpClient,
    private session: SessionsService
  ) { }

  public logIn(email, password): Observable<LoginResult> {
    const myHeader = new HttpHeaders({
      'Content-Type':  'application/json',
    });

    return <Observable<LoginResult>>this.http.post<LoginResult>(this.API_URL + '/login/logIn',
      {
        email: email,
        password: password
      }
      ,  { headers: myHeader });
  }

  public signIn(name, email,password, indirizzo, civio, citta, cap, cod_fisc,
                partner, affiliato: boolean, affMail): Observable<SignInResult> {
    const myHeader = new HttpHeaders({
      'Content-Type':  'application/json',
    });

    return <Observable<SignInResult>>this.http.post<SignInResult>(this.API_URL + '/login/createAccount',
      {
        name: name,
        email: email,
        password: password,
        partner: partner,
        affiliato: affiliato,
        aff_email: affMail,
        indirizzo: indirizzo,
        civico: civio,
        citta: citta,
        cap: cap,
        cod_fisc: cod_fisc
      }
      ,{ headers: myHeader });
  }

  public  sendMessageContacts(nome, email, telefono, messaggio) {
    return this.http.post(this.API_URL + '/open_operations/sendMessage', {
      nome: nome,
      email: email,
      telefono: telefono,
      messaggio: messaggio
    });
  }

  public resetPassword(email: string) {
    const myHeader = new HttpHeaders({
      'Content-Type':  'application/json',
    });

    return this.http.post(this.API_URL + '/login/resetPassword',
      {
        email: email
      }
      ,  { headers: myHeader });
  }

  public setNewPassword(passkey, password) {
    const myHeader = new HttpHeaders({
      'Content-Type':  'application/json',
    });

    return this.http.post(this.API_URL + '/login/setNewPassword',
      {
        passkey: passkey,
        password: password
      }
      ,  { headers: myHeader });
  }

  public getUser(): Observable<User> {
    const myHeader = new HttpHeaders({
      'Authorization': 'Basic ' + this.session.getAccessTokenUser(),
    })
      .append('Content-Type', 'application/json');


    return <Observable<User>>this.http.get<User>(this.API_URL + '/users/getIstance',
      { headers: myHeader });
  }

  getBills(): Observable<BillIstance> {
    const myHeader = new HttpHeaders({
      'Authorization': 'Basic ' + this.session.getAccessTokenUser(),
    })
      .append('Content-Type', 'application/json');


    return <Observable<BillIstance>>this.http.get<BillIstance>(this.API_URL + '/users/getBillings',
      { headers: myHeader });
  }

  getBill(software_name, date, id, price): Observable<BillHtml> {
    const myHeader = new HttpHeaders({
      'Authorization': 'Basic ' + this.session.getAccessTokenUser(),
    })
      .append('Content-Type', 'application/json');


    return <Observable<BillHtml>>this.http.post<BillHtml>(this.API_URL + '/users/getBill', {
      software_name:software_name,
      date:date,
      id:id,
      price:price
    },
      { headers: myHeader });
  }

  public activateAccount(email, passkey, partner) {
    return this.http.get(this.API_URL + '/login/confirmAccount?email='+email+'&passkey='+passkey+'&partner='+partner);
  }

  public getPartnerUsers(): Observable<Affiliate[]> {
    const myHeader = new HttpHeaders({
      'Authorization': 'Basic ' + this.session.getAccessTokenUser(),
    })
      .append('Content-Type', 'application/json');


    return <Observable<Affiliate[]>>this.http.get<Affiliate[]>(this.API_URL + '/partner/getAffiliates',
      { headers: myHeader });
  }

  /*
  public updateUser(user: User) {
    const myHeader = new HttpHeaders({
      'Authorization': 'Basic ' + this.session.getAccessTokenUser(),
    })
      .append('Content-Type', 'application/json');


    return this.http.post(this.API_URL + '/users/updateUserIstance',
      user,{ headers: myHeader });
  }

   */

  public addSoftwareUser(software) {
    const myHeader = new HttpHeaders({
      'Authorization': 'Basic ' + this.session.getAccessTokenUser(),
    })
      .append('Content-Type', 'application/json');


    return this.http.post(this.API_URL + '/users/addSoftware',
      software,{ headers: myHeader });
  }


  public sendActivationRequest(software: string) {
    const myHeader = new HttpHeaders({
      'Authorization': 'Basic ' + this.session.getAccessTokenUser(),
    });


    return this.http.get(this.API_URL + '/users/' + software + '/askForActivation',
      { headers: myHeader });
  }

  public getSoftwaresList(): Observable<SoftwaresList> {
    return <Observable<SoftwaresList>>this.http.get<SoftwaresList>(this.API_URL +
        '/open_operations/getSoftwaresInfo');
  }

  public getSoftware(name: string): Observable<Software> {
    console.log('name: '+ name)
    return <Observable<Software>>this.http.get<Software>(this.API_URL +
      '/open_operations/getSoftwaresInfo/'+name);
  }

  public getPartnerSoftwaresList(): Observable<SoftwaresList> {
    const myHeader = new HttpHeaders({
      'Authorization': 'Basic ' + this.session.getAccessTokenUser(),
    });
    return <Observable<SoftwaresList>>this.http.get<SoftwaresList>(this.API_URL +
      '/partner/getSoftwares', {headers: myHeader});
  }

  public updateSoftwareIstance(software: Software): Observable<{result:boolean, message:string}> {
    const myHeader = new HttpHeaders({
      'Authorization': 'Basic ' + this.session.getAccessTokenUser(),
    });
    return <Observable<{result:boolean, message:string}>>this.http.post<{result:boolean, message:string}>(this.API_URL +
      '/partner/updateSoftware', software, {headers: myHeader});
  }

  public createPartnerSoftwareIstance(software: Software): Observable<{result:boolean, message:string}> {
    const myHeader = new HttpHeaders({
      'Authorization': 'Basic ' + this.session.getAccessTokenUser(),
    });
    return <Observable<{result:boolean, message:string}>>this.http.post<{result:boolean, message:string}>(this.API_URL +
      '/partner/addSoftware', software, {headers: myHeader});
  }

  public ceckIdConto(idConto: string): Observable<CheckIdConto> {
    return <Observable<CheckIdConto>>this.http.get<CheckIdConto>(this.API_URL +
      '/open_operations/checkIdAccount?id_conto='+btoa(idConto));
  }

  public adminLogin(token: string): Observable<LoginResult> {
    const myHeader = new HttpHeaders({
      'Authorization': token,
    });

    return <Observable<LoginResult>>this.http.get<LoginResult>(this.API_URL +
      '/admin_operations/login',
      { headers: myHeader });
  }

  public getActivtionRequests(): Observable<ActivationRequest> {
    const myHeader = new HttpHeaders({
      'Authorization': 'Basic ' + this.session.getAccessTokenUser(),
    });

    return <Observable<ActivationRequest>>this.http.get<ActivationRequest>(this.API_URL +
      '/partner/getRequests',
      { headers: myHeader });
  }

  public deleteActivtionRequests(requestId: string) {
    const myHeader = new HttpHeaders({
      'Authorization': 'Basic ' + this.session.getAccessTokenUser(),
    });

    return this.http.post(this.API_URL +
      '/partner/deleteRequest?request_id='+requestId,
      '', { headers: myHeader });
  }

  public acceptActivtionRequests(requestId: string) {
    const myHeader = new HttpHeaders({
      'Authorization': 'Basic ' + this.session.getAccessTokenUser(),
    });

    return this.http.post(this.API_URL +
      '/partner/acceptRequest?request_id='+requestId,
      '', { headers: myHeader });
  }

  public updateSoftwareAdminIstance(soft: Software) {
    const myHeader = new HttpHeaders({
      'Authorization': this.session.getAccessTokenAdmin(),
    });

    return this.http.post(this.API_URL +
      '/admin_operations/updateAdminSoftwareInstance',
      soft, { headers: myHeader });
  }

  public getActivtionUsersRequests(): Observable<ActivationUserRequest> {
    const myHeader = new HttpHeaders({
      'Authorization': this.session.getAccessTokenAdmin(),
    });

    return <Observable<ActivationUserRequest>>this.http.get<ActivationUserRequest>(this.API_URL +
      '/admin_operations/getUsersRequests',
      { headers: myHeader });
  }

  public acceptActivtionUsersRequests(email: string) {
    const myHeader = new HttpHeaders({
      'Authorization': this.session.getAccessTokenAdmin(),
    });

    return this.http.post(this.API_URL +
      '/admin_operations/acceptUsersRequest?email='+email,
      '', { headers: myHeader });
  }

  updateUserAccessSoftwareProps(software: string, properties: SoftwareProperty[]) {
    const myHeader = new HttpHeaders({
      'Authorization': "Basic " + this.session.getAccessTokenUser(),
    });
    return this.http.post(this.API_URL +
      '/users/updateSoftwareProperties',
      {
        software_name: software,
        properties: properties
      }, { headers: myHeader })
  }

  getVpsInfo(): Observable<Vps[]> {
    const myHeader = new HttpHeaders({
      'Authorization': "Basic " + this.session.getAccessTokenUser(),
    });
    return <Observable<Vps[]>>this.http.get<Vps[]>(this.API_URL +
      '/users/getVpsInfo',
       { headers: myHeader })
  }

  getAdminVpsInfo(): Observable<Vps[]> {
    const myHeader = new HttpHeaders({
      'Authorization': this.session.getAccessTokenAdmin(),
    });
    return <Observable<Vps[]>>this.http.get<Vps[]>(this.API_URL +
      '/admin_operations/getAdminVps',
      { headers: myHeader })
  }

  getVpsActivationState(email): Observable<VpsActivationState> {
    return <Observable<VpsActivationState>>this.http.get<VpsActivationState>(this.API_URL +
      '/open_operations/getVpsActivationState/'+email)
  }

  changeVpsActivationState(email, state) {
    const myHeader = new HttpHeaders({
      'Authorization': 'Y2hkc3VvanZob25jZHNuNDM0bjNvZjg5ODQ5ODJ2Y2lydjhqOHE5cnZ1ODk4dXY4OXE4dTl2OHV3OThjdWU5dXZmZDl1c3ZmZHNjamQ4OWY=',
    });
    return this.http.post(this.API_URL +
      '/admin_operations/changeActivationState',
      {
        email:email,
        state:state
      }, { headers: myHeader })
  }

  addVpsFreeLicence() {
    const myHeader = new HttpHeaders({
      'Authorization': "Basic " + this.session.getAccessTokenUser(),
    });
    return this.http.get(this.API_URL +
      '/users/activateFreeVps',
      { headers: myHeader })
  }

  updateVps(vps: Vps) {
    const myHeader = new HttpHeaders({
      'Authorization': "Basic " + this.session.getAccessTokenUser(),
    });
    return this.http.post(this.API_URL +
      '/users/updateVps',
      vps, { headers: myHeader })
  }

  getReport(): Observable<OperationsReport> {
    return this.http.get<OperationsReport>(this.API_URL +
      '/open_operations/getReport',{});
  }

  checkSoftwareTried(email: string, software: string): Observable<DefaultResponse> {
    const myHeader = new HttpHeaders({
      'Authorization': "Basic " + this.session.getAccessTokenUser(),
    });
    return this.http.get<DefaultResponse>(this.API_URL +
      '/users/'+ software+ '/checkSoftwareTried', { headers: myHeader })
  }

  updateUserIdConto(user: User) {
    const myHeader = new HttpHeaders({
      'Authorization': "Basic " + this.session.getAccessTokenUser(),
    });
    return this.http.post(this.API_URL +
      '/users/updateUserIdConto',
      user, { headers: myHeader })
  }
}

export interface AgreementCreationResult {
  checkout_link: string,
  result: boolean
}

export interface ActivationRequest {
  requests:[
      {
        name:string,
        email:string,
        software_name:string,
        date:string,
        timestamp:number,
        request_id:number
      }
    ]
}

export interface OperationsReport {
  operations: [{
    symbol: string,
    time: string,
    profit: string
  }],
  id_conto: number,
  timestamp: string
}

export interface ActivationUserRequest {
  requests: [
      {
        email: string,
        name: string
      }
    ]
}

export interface SoftwaresList {
  softwares: [
      Software
    ]
}

export interface Software {
  versions: string,
  software_name: string,
  description: string,
  short_description: string,
  price: string,
  telegram_bot_token:string,
  approved: boolean,
  email: string,
  properties?: SoftwareProperty[],
  billingPeriod:string
}

export interface SoftwareProperty {
  name:string,
  value: string,
  type: PropertyType
}

export enum PropertyType {
  int,
  long,
  float,
  string,
  boolean
}

export interface CheckIdConto {
  result: boolean,
  free:boolean,
  email:string
}

export interface LoginResult {
  result:boolean,
  partner: boolean
}

export interface SignInResult {
  result:boolean,
  message: string
}

export interface Affiliate {
  email: string,
  passkey: string,
  account_activation: boolean,
  software_access: string,
  aff_email: string,
  softwares: [
    {
      software: Software,
      payment_recieved:
        [
          {
            importo: string,
            storno: string,
            data: string
          }
        ]
    }
  ]
}

export interface BillIstance {
  bills: Bill[]
}

export interface BillHtml {
  bill: string
}

export interface Bill {
  id: number
  date: string,
  user_email: string,
  price: string,
  user_name: string,
  "software_name": string
}

export interface Vps {
  email: string,
  id_conto: string,
  password_conto,
  broker_server: string,
  softwares : string,
  active: boolean,
  running: boolean,
  activation_date: string,
  free_plan: boolean,
  next_payment_date: string,
  last_payment_date: string,
  agreement_id:string,
  token_id:string,
  symbols:string
}

export interface VpsActivationState {
  state: string
}

export interface DefaultResponse {
  result: boolean
}
